<template>
    <div class="popup visible" id="no-internet-popup">
        <div class="popup-box">
            <icon-base width="66" height="66" viewBox="0 0 66 66"><icon-error-connection/></icon-base>

            <p class="message">{{message}}</p>

            <div class="buttons-box">
                        <span class="btn success" @click.prevent="cancelClick">
                            <span>Continue</span>
                        </span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex"
import IconBase from "../common/IconBase";
import IconErrorConnection from "./icons/IconErrorConnection";

export default {
    name: 'error-component',

    components: {IconErrorConnection, IconBase},

    data() {
        return {
            message: 'Connection Error'
        }
    },

    computed: {
        ...mapState({
            popupData: state => state.popupData,
        }),
    },

    methods: {
        ...mapMutations([
            'switchPopup',
        ]),
        cancelClick() {
            this.switchPopup(false);
        },
    },
    mounted() {
        if(this.popupData.message.length) {
            this.message = this.popupData.message;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
